import { styled } from '@linaria/react';
import { semantic, space } from '../../theme/tokens';

export const ScrollContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space[4]};
`;

export const SkeletonContainer = styled.div`
  display: grid;
  gap: ${space[4]};
`;

export const TimeslotDivider = styled.div`
  border-top: 1px solid ${semantic.border.subtle};
  margin: ${space[4]} 0;
  width: 100%;
`;
